import PortalIdParser from 'PortalIdParser';
import { isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import I18n from 'I18n';
import { getRelationalReportDatasetId } from 'reporting-data/report/relationalReportGetters';
import { useTracker } from '../../utils/hooks/useTracker';
import { EVENTS } from '../../utils/usageTracker';
import ActionButton from '../ActionButton';
// @ts-expect-error untyped module
import { useUserRoleFromScopes } from '../../utils/trackingUtils';
// @ts-expect-error untyped module
import { getTemplateKey } from '../../data/schemas/reportSchema';
// @ts-expect-error untyped module
import { getDefaultReportActionEventProperties } from '../report-action-wrapper';
import { redirectToUrl } from '../../utils/windowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewInDatasetsButton = ({
  report,
  appUsageTracker,
  trackingProperties
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const userRole = useUserRoleFromScopes();
  if (!isRelationalReport(report)) {
    return null;
  }
  const datasetId = getRelationalReportDatasetId(report);
  if (typeof datasetId !== 'number') {
    return null;
  }
  function onClick() {
    if (usageTracker) {
      const template = getTemplateKey(report);
      const defaultReportActionEventProperties = getDefaultReportActionEventProperties(report);
      usageTracker.track(EVENTS.clickGoToDatasets, Object.assign({
        actionType: 'navigate',
        action: 'go-to-datasets',
        role: userRole,
        templateKey: template
      }, trackingProperties, defaultReportActionEventProperties, {
        assetType: trackingProperties.assetType || defaultReportActionEventProperties.assetType
      }));
    }
    redirectToUrl(`/reporting-datasets/${PortalIdParser.get()}/view/${datasetId}/preview`);
  }
  return /*#__PURE__*/_jsx(ActionButton, {
    onClick: onClick,
    label: I18n.text('reporting-action-components.actions.viewInDatasets.button.text')
  });
};